var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext, useEffect, useReducer } from 'react';
import { UpdateEvents } from '../ChromeProvider';
import { FAVORITE_PAGE_URL, post } from '../utils/fetch';
import ChromeContext from '../ChromeContext/ChromeContext';
function handleFavoritePage(pathname, favorite) {
    return post(FAVORITE_PAGE_URL, {
        pathname: pathname,
        favorite: favorite,
    });
}
var useFavoritePages = function () {
    var _a = useContext(ChromeContext), subscribe = _a.subscribe, unsubscribe = _a.unsubscribe, getState = _a.getState, setFavoritePages = _a.setFavoritePages;
    var _b = useReducer(function (count) { return count + 1; }, 0), forceRender = _b[1];
    function handleFavoriteAPICall(pathname, favorite) {
        return __awaiter(this, void 0, void 0, function () {
            var prevPages, newPages, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prevPages = getState().favoritePages;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        setFavoritePages(__spreadArray(__spreadArray([], prevPages, true), [{ pathname: pathname, favorite: favorite }], false));
                        return [4, handleFavoritePage(pathname, favorite)];
                    case 2:
                        newPages = _a.sent();
                        setFavoritePages(newPages);
                        return [2, newPages];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        setFavoritePages(prevPages);
                        return [2, prevPages];
                    case 4: return [2];
                }
            });
        });
    }
    function favoritePage(pathname) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, handleFavoriteAPICall(pathname, true)];
            });
        });
    }
    function unfavoritePage(pathname) {
        return handleFavoriteAPICall(pathname, false);
    }
    useEffect(function () {
        var subsId = subscribe(UpdateEvents.favoritePages, forceRender);
        return function () {
            unsubscribe(subsId, UpdateEvents.favoritePages);
        };
    }, []);
    return { favoritePages: __spreadArray([], getState().favoritePages, true), favoritePage: favoritePage, unfavoritePage: unfavoritePage, initialized: getState().initialized };
};
export default useFavoritePages;
//# sourceMappingURL=useFavoritePages.js.map